import { AxiosError } from 'axios';
import { functionalActivityApi } from '@/entities/FunctionalActivity';
import { toastError, toastSuccess, useCustomToast } from '@/shared/lib';

export function useFunctionalActivityEdit() {
  const toast = useCustomToast();

  async function updateFunctionalActivity(
    id: number,
    name: string
  ): Promise<{ success: boolean; nameError?: string }> {
    try {
      await functionalActivityApi.update(id, { name });
      toastSuccess(toast, 'Atividade atualizada com sucesso');
      return { success: true };
    } catch (err) {
      if (err instanceof AxiosError && err.response?.data?.errors?.name?.[0]) {
        const nameError = err.response.data.errors.name[0];
        toastError(toast, nameError);
        return { success: false, nameError };
      }
      toastError(toast, 'Erro ao atualizar Atividade, tente novamente.');
      return { success: false };
    }
  }

  return { updateFunctionalActivity };
}
